module.exports = __webpack_public_path__ + "static/bg-2545c45fe41ff430e743a4f884a97180.jpg";